import styled from '@emotion/styled'
interface TextProps {
  fontSize?: string
  weight?: string
  color?: string
  lineHeight?: string
  align?: 'left' | 'center' | 'right' | 'justify'
  textWidth?: string
  fontSizeSm?: string
  centered?: boolean
  justified?: boolean
  flex?: boolean
}

export const StyleText = styled.p<TextProps>`
  font-size: ${(props: any) => props.fontSize || 16}px;
  font-weight: ${(props: any) => props.weight || 'normal'};
  color: ${(props: any) =>
    props.color
      ? props.theme.colors[props.color as keyof typeof props.theme.colors] ||
        props.color
      : props.theme.colors.black};
  line-height: ${(props: any) => props.lineHeight || '1.5'};
  text-align: ${(props: any) => props.align || 'left'};
  width: ${(props: any) => props.textWidth}px;

  @media (max-width: 768px) {
    font-size: ${(props) => props.fontSizeSm || 0.8}rem;
    width: 100%;
    text-align: ${(props: any) => {
      if (props.centered) return 'center'
      if (props.justified) return 'justify'
      return 'start'
    }};
  }

  display: ${(props: any) => (props.flex ? 'flex' : '')};
  align-items: center;
  gap: 10px;
`

export const StyleTextWrapper = styled.div<{ align?: string; rowGap?: string }>`
  display: flex;
  flex-direction: column;
  row-gap: ${(props: any) => props.rowGap || 0}px;
  flex: 2;
  align-items: ${(props: any) => props.align || 'start'};
`

export const StyleTextWrapperAlternate = styled.div<{ rowGap?: string }>`
  display: flex;
  flex: 2;
  height: full;
  flex-direction: column;
  row-gap: ${(props: any) => props.rowGap || 18}px;
  @media (max-width: 480px) {
    row-gap: 8px;
  }
`
